// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2QMLS","col":"CardReaderDesc_col__3-OxO","label":"CardReaderDesc_label__2XCgp"};